import { defineStore } from "pinia";
import { ref, markRaw } from "vue";
import type { Component } from "vue";

export interface ModalData {
  title?: string,
  textContent?: string,
  component?: Component | null,
  componentProps?: Record<string, unknown> | null,
  componentEvents?: Record<string, (...args: unknown[]) => unknown>,
  confirmText?: string,
  confirmMethod?: ((...args: unknown[]) => unknown) | null,
  destructive?: boolean
  size?: "sm" | "md" | "lg"
}

export const useModalStore = defineStore("modal", () => {
  const isModalOpen = ref(false);
  const initialModalData: ModalData = {
    title: "",
    textContent: "",
    component: null,
    componentProps: null,
    componentEvents: {},
    confirmText: "",
    confirmMethod: null,
    destructive: false,
    size: "sm"
  };
  const modalData = ref<ModalData>({...initialModalData});

  function openModal(params: ModalData) {
    modalData.value = {
      ...modalData.value,
      ...params,
      component: params.component ? markRaw(params.component) : null
    };
    isModalOpen.value = true;
  }

  function closeModal() {
    isModalOpen.value = false;
    setTimeout(() => {
      modalData.value = {...initialModalData};
    }, 200);
  }

  function confirmModal() {
    if (modalData.value.confirmMethod) modalData.value.confirmMethod();
    closeModal();
  }

  return {
    isModalOpen,
    modalData,
    openModal,
    closeModal,
    confirmModal
  };
});
